<template>
	<div class="table-wrapper" @scroll.passive="onScroll">
		<!-- <div class="date-range">
			<span>Date Range</span>
			<el-date-picker
				v-model="dateRange"
				type="daterange"
				range-separator="To"
				start-placeholder="Start date"
				end-placeholder="End date"
				format="MMM d, yyyy"
				:default-time="['00:00:00', '23:59:59']">
			</el-date-picker>
		</div> -->
		<!-- <div :class="['clipboard', {sticky: scrollSticky}]" >
			<el-checkbox v-model="selectAll">Select All</el-checkbox>
			<span 
				@mouseover="copySelectedState = true"
				@mouseout="copySelectedState = false">
				<el-button class="outline-button" size="medium"
					@click="copySelected"
					:disabled="notes.length === 0">
					Copy Selected
				</el-button>
				<el-button class="outline-button" size="medium"
					@click="openChartNoteDialog"
					:disabled="notes.length === 0">
					Open Selected
				</el-button>
			</span>
		</div> -->
		<el-card v-if="!event.filter(e => e.type.includes('questionnaire')).length" class="no-notes-section">
            <img :src="require('../image/no-notes.png')"/>
            <p class="no-notes">No Notes</p>
        </el-card>
		<div>
			<div v-for="(event, index) in selected" 
				:key="index"
				class="chart-event">
				<!-- <el-checkbox class="select-box" v-model="selectNote" :label="event.title">{{ event.title }} {{ getNoteCount(event.bucketNote) }}</el-checkbox> -->
				<div v-if="event.type === 'questionnaire'" 
					:class="['select-array', event.title.toLowerCase().replace(' ', '-')]">
					<QuestionnaireChart 
						:patient="patient"
						:questionnaireBucketNote="event.bucketNote"
						:select-all="selectNote.includes(event.title)"
						:show-selected="copySelectedState"
						:key="event.key"
						@change-quest-notes="updateQuestNotes"></QuestionnaireChart>
				</div>
				<EditChart v-else
					v-model="event.note"
					:class="['select-wrapper', event.title.toLowerCase().replace(' ', '-')]"
					:selected="isGoingToCopy(event.title)"
					>
				</EditChart>
			</div>
		</div>
		<el-dialog
			:visible.sync="openChartNote"
			:append-to-body="true"
			class="send-now-modal"
			@close="closeChartNoteDialog"
			v-if="openChartNote"
			:close-on-click-modal="false"
			width="65%">
			<div slot="title">
				Selected Notes
			</div>
			<div style="padding: 10px; border: 1px solid #cccccc">
				<TextEdit v-model="questNote"></TextEdit>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="copyChartNoteDialog" type="success" size="medium">Copy</el-button>
				<el-button @click="closeChartNoteDialog" type="primary" size="medium">Close</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import format from '@/module/util/format'
import generate from './generate'
import { v4 as uuidv4 } from 'uuid'

import CopyMixin from './mixin/copy'
import QuestionnaireBucketMixin from '../mixin/questionnaire-bucket'

import QuestionnaireChart from './QuestionnaireChart'
import EditChart from './EditChart'
import TextEdit from '@/module/component/TextEdit'


const expandTitle = 'Questionnaires'

export default {
	name: 'chart-table',

	mixins: [QuestionnaireBucketMixin, CopyMixin],

	props: {
		patient: {
			type: Object
		},
		event: {
			type: Array
		}
	},

	data() {
		const today = new Date()
		return {
			selected: this.eventType,
			copied: false,
			dateRange: [new Date(new Date().setMonth(today.getMonth() - 3)), today],
			selectAll: false,
			selectType: {},
			selectNote: [],
			questNote: '',
			copySelectedState: false,
			scrollSticky: false,
			openChartNote: false
		}
	},

	watch: {
		selectAll: {
			immediate: true,
			handler(newVal) {
				if(newVal) {
					this.selectNote = this.eventType.map((event) => event.title)
				}
				else
					this.selectNote = []
			}
		},
		eventType: {
			immediate: true,
			handler(newVal) {
				if(newVal)
					this.selected = newVal
			}
		}

	},

	computed: {
		...mapGetters('content', [
			'getContent',
		]),
		...mapGetters('provider', [
			'getCurrentProvider',
			'getProvidersIdArray',
			'allPatientsChosen',
			'getPatientMessages',
			'getPatientSchedule'
		]),
		...mapState('provider', ['patientAnalytics', 'record']),

		patientSavedCharts() {
			return this.record.charts[this.patient.id]
		},

		thisPatientAnalytics() {
			return this.patientAnalytics[this.patient.id]
		},
		eventType() {
			var type = {}
			this.event.forEach((e) => {
				if (e.type)
					type[e.type.split(':')[0]] = true
			})


			var eventType = []
			// if (type.appointment)
			// 	eventType.push({
			// 		title: 'Chief Complaints',
			// 		type: 'complaints',
			// 		copied: false,
			// 		note: generate.appointment.call(this, this.patient, this.filteredEvent.filter((e) => e.type.startsWith('appointment') && e.provider === this.getCurrentProvider))
			// 	})
			// if (type.symptom || type.vital || type.food || type.water || type.excretion)
			// 	eventType.push({
			// 		title: 'HPI',
			// 		type: 'hpi',
			// 		copied: false,
			// 		note: generate.patient.call(this, this.patient, this.filteredEvent.filter((e) => (
			// 				e.type.startsWith('symptom') || e.type.startsWith('vital') ||
			// 				e.type.startsWith('food') || e.type.startsWith('water') || e.type.startsWith('excretion')
			// 		)))
			// 	})
			// If any questionnaire exists
			if (type.questionnaire) {

				// Get the questionnaire buckets from mixin functions
				const questionnaireBucket = this.getQuestionnaireBuckets(
					this.getPatientSchedule(this.patient.id),
					this.getPatientMessages(this.patient.id),
					this.event.filter((e) => e.type.startsWith('questionnaire') && this.allPatientsChosen ? this.getProvidersIdArray.includes(e.provider) : e.provider === this.getCurrentProvider), 'ctc')


				let chartedQuestionnaireBucket = questionnaireBucket.map((bucket) => {
					if(bucket.type === 'event') {
						const profileQuestionnaireOrder = this.getProfileQuestionaireOrder(bucket.event)
						if(profileQuestionnaireOrder.length > 1)
							bucket.refQuestionnaireList.sort((qA,qB) => this.sortByProfileOrder(qA.type.split(':')[1], qB.type.split(':')[1], profileQuestionnaireOrder))
					}
						
					return {
						...bucket,
						note: generate.questionnaire.call(this, this.patient, bucket.refQuestionnaireList, this.patientAnalytics[this.patient.id])
					}
					
				}).filter((bucket) => Array.isArray(bucket.note) && bucket.note.length > 0)

				eventType.push({
					title: 'Questionnaires',
					type: 'questionnaire',
					copied: false,
					bucketNote: chartedQuestionnaireBucket,
					key: uuidv4()
				})
			}
				
			// if (type.medication)
			// 	eventType.push({
			// 		title: 'Medications',
			// 		type: 'medication',
			// 		copied: false,
			// 		note: generate.medication.call(this, this.patient,
			// 				this.filteredEvent.filter((e) => e.type.startsWith('medication') && ! e.archived ))
			// 	})
			return eventType
		},
		notes() {
			return this.eventType.map((event) => this.getNotes(event.title)).filter((note) => note).join('\n\n')
		}
	},

	methods: {
		...format,
		onScroll($event) {
			this.scrollSticky = ( $event.target.scrollTop > 60 ) ? true : false
		},
		renderHTML(note) {
			return note.replace('\n', '<br>')
		},
		isGoingToCopy(title) {
			return this.selectNote.includes(title) && this.copySelectedState
		},
		getNotes(title) {
			if(title === expandTitle) {
				return this.questNote
			}
			else if(!this.selectNote.includes(title))
				return null

			return this.selected.find((event) => event.title === title).note
		},
		copySection(section, e) {
			this.copy(section.note)
			if (e && e.target)
				e.target.select()

			section.copied = true
			setTimeout(() => { section.copied = false }, 1000)
		},
		copySelected() {
			this.copy(this.notes)
			this.copied = true
			setTimeout(() => { this.copied = false }, 1000)
		},
		selectionChange(selected) {
			this.selected = selected
		},
		getNoteCount(bucketNote) {
			return Array.isArray(bucketNote) ? '(' + bucketNote.reduce((acc, bucket) => acc + bucket.note.length, 0) + ')' : ''
		},
		updateQuestNotes(notes) {
			this.questNote = notes.replaceAll('\n', '<br>')
		},
		openChartNoteDialog() {
			this.openChartNote = true
		},
		closeChartNoteDialog() {
			this.openChartNote = false

		},
		copyChartNoteDialog() {
			this.copy(this.questNote)
		}
	},

	components: {
		EditChart,
		QuestionnaireChart,
		TextEdit
	}
}
</script>

<style lang="scss" scoped>
@import "./style.scss"
</style>

<style scoped>
.date-range >>> .el-date-editor span.el-range-separator {
	font-size: 14px;
	padding: 0;
	color: #333333;
}
.el-checkbox.select-box >>> .el-checkbox__label {
	font-size: 14px;
	font-weight: bold;
	text-transform: uppercase;
}
.select-wrapper .el-checkbox >>> .el-checkbox__label {
	display: none;
}
.underline-button >>> span {
    border-bottom: 1px solid;
}
.questionnaires >>>.select-text b {
	color: #833e93;
}
.hpi >>> .select-text b {
	color: #e28816;
}
.medications >>> .select-text b {
	color: #c45531;
}
</style>